import "./AdManagerBannersEditDialog.scss";
import axios from "axios";
import { getImageSize, getTokenHeader } from "@/helpers/commonHelper";
import { uploadFile } from "@/helpers/fileHelper";
import { getPrincipalsWithAdZoneInAppdinxLogin } from "@/helpers/adManagerHelper";
import { updateAllNewsInApp } from "@/helpers/newsHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerBannersEditDialog",
  props: {
    dialog: { type: Boolean, default: false },
    editedItem: { type: Object, default: null },
    currentPrincipal: { type: String, default: "" },
    banners: { type: Array, default: () => [] },
    zones: { type: Array, default: () => [] },
    groups: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerDialog: false,
      menuStart: false,
      menuEnd: false,
      localItem: this.blank(),
      initialItem: {},
      valid: false,
      saving: false,
      mainPeacock: "#00636C",
      bannerPictureDragging: {
        desktop: false,
        mobile: false
      },
      endAfterStart: () =>
        new Date(this.localItem.end_date) >=
          new Date(this.localItem.start_date) || "Ende muss ≥ Start sein"
    };
  },
  watch: {
    async dialog(val) {
      this.innerDialog = val;
      if (val) {
        this.fillData();
      }
    },
    startDate(v) {
      if (v) this.localItem.start_date = new Date(v).toISOString();
    },
    endDate(v) {
      if (v) this.localItem.end_date = new Date(v).toISOString();
    }
  },
  computed: {
    isValidHref() {
      if (!this.localItem.href?.length) {
        return false;
      }
      try {
        const regex = /^(https?:\/\/)?(www\.)?((?!.*www)[a-zA-Z-]+\.)[a-z]+\S*$/;
        return regex.test(this.localItem.href);
      } catch {
        return false;
      }
    },
    startDate: {
      get() {
        return this.localItem.start_date
          ? new Date(this.localItem.start_date)
          : new Date();
      },
      set(v) {
        this.localItem.start_date = new Date(v).toISOString();
      }
    },
    endDate: {
      get() {
        return this.localItem.end_date
          ? new Date(this.localItem.end_date)
          : new Date();
      },
      set(v) {
        this.localItem.end_date = new Date(v).toISOString();
      }
    },
    startDateStr: {
      get() {
        return this.localItem.start_date
          ? new Date(this.localItem.start_date).toISOString().slice(0, 10)
          : new Date().toISOString().slice(0, 10);
      },
      set(yyyyMMdd) {
        // setze ISO mit 00:00 lokal
        const d = new Date(yyyyMMdd + "T00:00:00");
        this.localItem.start_date = d.toISOString();
      }
    },
    endDateStr: {
      get() {
        return this.localItem.end_date
          ? new Date(this.localItem.end_date).toISOString().slice(0, 10)
          : new Date().toISOString().slice(0, 10);
      },
      set(yyyyMMdd) {
        const d = new Date(yyyyMMdd + "T23:59:59");
        this.localItem.end_date = d.toISOString();
      }
    },
    startDateDisplay() {
      return new Date(this.localItem.start_date).toLocaleDateString("de-DE");
    },
    endDateDisplay() {
      return new Date(this.localItem.end_date).toLocaleDateString("de-DE");
    },
    appAdZones() {
      return this.zones.filter(zone => zone.target === "app");
    },
    updateInApp() {
      const localItemGroupZones = this.groups
        .filter(group => this.localItem.groups.includes(group._id))
        .map(group => group.zones)
        .flat();

      const localItemZoneIds = [
        ...localItemGroupZones,
        ...this.localItem.zones
      ].map(zone => zone._id ?? zone);

      const localItemAppZones = this.appAdZones.filter(zone =>
        localItemZoneIds.includes(zone._id)
      );

      if (localItemAppZones?.length) {
        const keys = [
          "active",
          "start_date",
          "end_date",
          "picture.desktop.url",
          "picture.mobile.url"
        ];

        const getValue = (obj, path) =>
          path.split(".").reduce((o, p) => o && o[p], obj);
        if (
          keys.some(
            key =>
              getValue(this.localItem, key) !== getValue(this.initialItem, key)
          )
        ) {
          return true;
        }
      }

      const initialItemGroupZones = this.groups
        .filter(group => this.initialItem.groups.includes(group._id))
        .map(group => group.zones)
        .flat();

      const initialItemZoneIds = [
        ...initialItemGroupZones,
        ...this.initialItem.zones
      ].map(zone => zone._id ?? zone);

      const initialItemAppZones = this.appAdZones
        .filter(zone => initialItemZoneIds.includes(zone._id))
        .map(zone => zone._id);

      const arraysEqual =
        localItemAppZones.length === initialItemAppZones.length &&
        localItemAppZones.every((id, idx) => id === initialItemAppZones[idx]);
      return !arraysEqual;
    },
    canSelectZones() {
      return this.localItem.groups.length === 0;
    },
    canSelectGroups() {
      return this.localItem.zones.length === 0;
    }
  },
  methods: {
    async createSuccess(successMessage) {
      await this.$store.dispatch("createSuccess", successMessage);
    },
    async createError(error) {
      await this.$store.dispatch("createError", error);
    },
    blank() {
      return {
        _id: "",
        active: true,
        principal_id: this.currentPrincipal,
        name: "",
        href: "",
        picture: {
          desktop: {
            title: "",
            url: "",
            originalFilename: "",
            width: null,
            height: null
          },
          mobile: {
            title: "",
            url: "",
            originalFilename: "",
            width: null,
            height: null
          }
        },
        start_date: new Date().toISOString(),
        end_date: new Date(Date.now() + 7 * 86400000).toISOString(),
        zones: [],
        groups: [],
        is_link: true
      };
    },
    fillData() {
      const base = this.editedItem
        ? JSON.parse(JSON.stringify(this.editedItem))
        : this.blank();
      if (!base.picture) {
        base.picture = {
          desktop: {
            title: "",
            url: "",
            originalFilename: "",
            width: null,
            height: null
          },
          mobile: {
            title: "",
            url: "",
            originalFilename: "",
            width: null,
            height: null
          }
        };
      }
      base.principal_id = this.currentPrincipal;
      this.localItem = base;
      this.initialItem = window.structuredClone(this.localItem);
      this.$nextTick(() => this.$refs.form?.resetValidation());
    },
    async onSave() {
      const ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }

      this.saving = true;

      const { desktop, mobile } = this.localItem.picture;
      if (desktop.url && !(desktop.width && desktop.height)) {
        const { width, height } = await getImageSize(desktop.url);
        this.localItem.picture.desktop.width = width;
        this.localItem.picture.desktop.height = height;
      }
      if (mobile.url && !(mobile.width && mobile.height)) {
        const { width, height } = await getImageSize(mobile.url);
        this.localItem.picture.mobile.width = width;
        this.localItem.picture.mobile.height = height;
      }

      const headers = getTokenHeader();

      // Payload-Shape an API anpassen falls nötig
      const payload = {
        ...this.localItem,
        principal_id: this.currentPrincipal
      };

      if (!payload._id) delete payload._id;

      try {
        if (this.localItem._id) {
          await axios.put(
            env.ad_manager_api_client_url + "ad/banners/" + this.localItem._id,
            payload,
            { headers }
          );
        } else {
          const res = await axios.post(
            env.ad_manager_api_client_url + "ad/banners",
            payload,
            { headers }
          );
          this.localItem._id = res.data?._id || this.localItem._id;
          this.localItem.href = res.data?.href || this.localItem.href;
        }

        if (this.updateInApp) {
          new Set(
            this.appAdZones
              .map(zone => getPrincipalsWithAdZoneInAppdinxLogin(zone._id))
              .filter(arr => Array.isArray(arr) && arr.length > 0)
              .flat()
              .map(principal => principal.id)
          ).forEach(principalId => {
            updateAllNewsInApp(principalId, headers);
          });
        }
        this.$emit("afterSave");
        this.onCancel();
      } catch (e) {
        await this.createError("Speichern fehlgeschlagen");
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
    onCancel() {
      this.$emit("close");
      this.$emit("update:dialog", false);
    },
    async setBannerPicture(e, format) {
      this.bannerPictureDragging = false;

      const file = e?.dataTransfer?.files?.[0] ?? e;
      if (!file) {
        return;
      }
      try {
        const uploadedFile = await uploadFile(
          file,
          null,
          "admanager",
          this.currentPrincipal,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        const { width, height } = await getImageSize(uploadedFile.url);

        this.localItem.picture[format] = {
          originalFilename: file.name,
          width,
          height,
          ...uploadedFile
        };
      } catch (e) {
        console.error(e);
        await this.createError("Bild konnte nicht hochgeladen werden.");
      }
    },
    removeBannerPicture(format) {
      const blank = this.blank();
      this.localItem.picture[format] = {
        ...blank.picture[format]
      };
    }
  }
};
